import { baseApi } from 'core/api';

const state = () => ({});

const getters = {};

const actions = {
    updateInboxesEmail(data) {
        const params = {
            items: [data],
            sms_message_type: 'body',
        };

        return baseApi.put('core/teams/update-emails-to-sms', params).then((response) => {
            return response.data;
        });
    },
};

export default {
    state,
    getters,
    actions,
};
